<template>
  <h5 class="mb-1 fs-7 text-gray-700 mb-2">Выгодоприобретатель</h5>
  <div class="podft-list p-4 rounded border mb-3">
    <div class="podft-list__item">
      <div class="text-gray-600 fs-7"> {{beneficiary.person ? 'ФИО' : ''}}
        <span class="text-gray-800" :class="beneficiary.person ? 'float-end' : ''">{{ beneficiary.title }}</span>
      </div>
    </div>
    <div class="podft-list__item">
      <div class="text-gray-600 fs-7"> {{beneficiary.person ? 'ИИН' : 'БИН'}}
        <span class="text-gray-800 float-end">{{ beneficiary.iin }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PolicyBeneficiary',
  props: {
    beneficiary: null
  }
}
</script>

<style scoped>

</style>